import React from 'react';

import { Skeleton } from '../../../skeleton/skeleton';
import { SKELETON_NUMBER_OF_OPTIONS_TO_SHOW } from '../../add-to-cart-drawer.const';
import { ColorOptionsSkeleton } from '../color-options-skeleton/color-options-skeleton';

interface Props {
    productName: string;
}

export const ProductSkeleton = ({ productName }: Props) => (
    <div className='bs-add-to-cart-drawer__product'>
        <Skeleton className='bs-add-to-cart-drawer__image-wrapper' />
        <div className='bs-add-to-cart-drawer__product-info'>
            <span className='bs-add-to-cart-drawer__product-name'>{productName}</span>
            <Skeleton className='bs-add-to-cart-drawer__price bs-add-to-cart-drawer__price-skeleton' />
            <ColorOptionsSkeleton count={SKELETON_NUMBER_OF_OPTIONS_TO_SHOW} />
        </div>
    </div>
);
